// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0264dd93","239":"a9986e09","455":"2855abca"}[chunkId] + ".chunk.js";
};